module.exports = __webpack_public_path__ + "img/biophoto.f4c92e02.jpg";